var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "writer" },
    [
      _c("studip-icon", {
        attrs: { shape: "blubber", size: "30", role: "info" }
      }),
      _vm._v(" "),
      _c("textarea", {
        attrs: {
          placeholder: "Schreib was, frag was. Enter zum Abschicken.".toLocaleString()
        },
        on: {
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.submit($event)
            },
            _vm.saveCommentToSession
          ],
          change: _vm.saveCommentToSession
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "upload",
          attrs: { title: "Datei hochladen".toLocaleString() }
        },
        [
          _c("input", {
            staticStyle: { display: "none" },
            attrs: { type: "file", multiple: "" },
            on: { change: _vm.upload }
          }),
          _vm._v(" "),
          _c("studip-icon", { attrs: { shape: "upload", size: "30" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }